<template>
  <div class="folderCreationComponent">
    <div class="tree-menu">

      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#F9BF3B">
      </loading>


      <b-form v-on:submit.prevent="createFolder()">
        <b-form-group id="create-folder-name-group" label="Nom du dossier" label-for="create-folder-name-input" class="mandatory-input">
          <b-form-input
            v-model="name" type="text"
            maxlength="250"
            placeholder="Nom du dossier"
            id="create-folder-name-input"
            @input="$v.name.$touch()"
            :state="$v.name.$dirty ? !$v.name.$error : null">
          </b-form-input>
          <div class="form-error" v-if="$v.name.error">Le nom du dossier doit faire entre 2 et 250 caractères</div>
        </b-form-group>

        <b-form-group label="Planification du crawling" class="mandatory-input">
          <cronExpressionInputComponent v-model="cronExpression" @valid="cronValid = $event" />
        </b-form-group>

        <b-form-group id="create-folder-requete-group"
          label="Requêtes associées"
          label-for="create-folder-requete-input">
          <b-form-select
            v-model="selectedRequetes"
            id="create-folder-requete-input"
            :options="requetesCheckboxOptions"
            multiple
            :select-size="5">
          </b-form-select>
        </b-form-group>

        <b-form-group id="create-folder-parent-group"
          label="Dossier parent"
          label-for="create-folder-parent-input">
            <vue-bootstrap-typeahead
              ref="parentFilterAutocomplete"
              v-model="parentFilterName"
              :data="parentsFilter"
              :serializer="item => item.name"
              @hit="parentObject = $event"
               placeholder="Rentrez le nom du dossier parent ou laissez vide"
            />
        </b-form-group>

        <b-form-group id="create-folder-notes-group" label="Notes" label-for="create-folder-notes-input">
          <b-form-textarea
            v-model="notes" type="text"
            placeholder="Notes"
            id="create-folder-notes-input"
            rows="2"
            maxLength="500"
            @input="$v.notes.$touch()"
            :state="$v.notes.$dirty ? !$v.notes.$error : null">
          </b-form-textarea>
        </b-form-group>


        <b-button
          pill block type="submit" variant="outline-dark" class="mt-2"
          :disabled="isInvalidFolder">
            Créer un nouveau dossier
        </b-button>
      </b-form>



    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

import { APIFolder } from '@/api/APIFolder'
import { APIRequete } from '@/api/APIRequete'
import cronExpressionInputComponent from '@/components/folder/cronExpressionInputComponent'

const apiFolder = new APIFolder()
const apiRequete = new APIRequete()

export default {
  name: 'folderCreationComponent',
  props: {
    token: String
  },
  components: {
    cronExpressionInputComponent,
    Loading,
    VueBootstrapTypeahead
  },
  mixins: [
    validationMixin
  ],
  data() {
     return {
       // REQUETES
       requetes: [],
       requetesCheckboxOptions: [],
       isLoadingRequetes: false,

       isCreatingFolder: false,
       cronExpression: '',
       cronValid: true,
       name: '',
       notes: '',
       parent: null,
       parentsFilter: [],
       parentFilterName: '',
       parentObject: null,
       selectedRequetes: [],
     }
  },
  validations: {
    name: {
      minLength: minLength(2),
      maxLength: maxLength(250),
      required
    },
    notes: {
      maxLength: maxLength(512)
    }
  },
  computed: {
    isLoading () {
      if (this.isLoadingRequetes || this.isCreatingFolder) {
        return true
      }
      return false
    },
    isInvalidFolder () {
      if (this.$v.$invalid) {
        return true
      }
      if (!this.cronValid) {
        return true
      }
      return false
    },
  },
  watch: {
    parentFilterName(newQuery) {
      if (newQuery == '') {
        this.parentsFilter = []
        this.parentObject = null
      }
      else if (newQuery.length >= 3) {
        apiFolder.searchFoldersByName(this.token, newQuery)
        .then((res) => {
          this.parentsFilter = res.data
        })
      }
    },
    requetes: function(newRequetes) {
      this.requetesCheckboxOptions = newRequetes.map(r => ({ text: r.name, value: r.id }))
    }
  },
  mounted: function() {
    this.getAllRequetes()
  },
  methods: {
    createFolder () {
      this.isCreatingFolder = true
      const data = {
        'cron_expression': this.cronExpression,
        'name': this.name,
        'notes': this.notes,
        'requetes': this.selectedRequetes,
      }

      if (this.parentObject) {
        data['parent'] = this.parentObject.id
      }


      apiFolder.createFolder(this.token, data)
      .then(() => {
        this.$emit('folder-created')
      })
      .catch((error) => {
        this.$emit('folder-creation-error')
        throw new Error('RequeteCreation createRequete API Error : ' + String(error))
      })
      .finally(() => {
        this.isCreatingFolder = false
      })

    },

    getAllRequetes () {
      this.isRequetesLoading = true
      apiRequete.getAllRequetes(this.token)
      .then((result) => {
        this.requetes = result.data
      })
      .catch((error) => {
        throw new Error('RequeteList getAllRequetes API Error : ' + String(error))
      })
      .finally(() => {
        this.isRequetesLoading = false
      })
    },

  }
}
</script>
